<template>
  <div class="tradeRecords">
    <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" :auto-fill="false" ref="loadmore">
      <mt-header title="交易记录">
        <mt-button icon="back" slot="left" @click.native="$router.go(-1)">返回</mt-button>
      </mt-header>
      <!-- 列表 -->
      <div class="list_wrap">
        <div class="list" v-for="(fundList, index) in fundList" :key="index">
          <div>
            <p>{{fundList.content}}</p>
            <span>{{fundList.createTime | formatDate}}</span>
          </div>
          <div :class="{'output':output}">{{fundList.showBalance}}</div>
        </div>
      </div>
    </mt-loadmore>
  </div>
</template>

<script>
import {formatDate} from '../assets/js/date.js'
import { Indicator } from 'mint-ui'
export default {
  name: 'tradeRecords',
  data () {
    return {
      output: false,
      fundList: '',
      searchCondition: {
        pageNo: '0',
        pageSize: '30'
      },
      allLoaded: false,
      scrollMode: 'auto'
    }
  },
  filters: {
    formatDate (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm')
    }
  },
  mounted () {
    // 初始化加载区
    this.fundHistoryData()
  },
  methods: {
    loadTop: function () {
      this.fundHistoryData()
      this.$refs.loadmore.onTopLoaded()
    },
    loadBottom: function () {
      this.more()
      this.$refs.loadmore.onBottomLoaded()
    },
    fundHistoryData: function () {
      this.accountId = this.STATE.state.loginId
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      let _this = this
      this.axios.get('/url/fund/fundHistory?showCount=30&pageNo=0&accountId=' + _this.accountId + '')
      .then(function (res) {
        Indicator.close()
        _this.fundList = res.data.data.list
        console.log(_this.fundList)
      }).catch(function (response) {
        Indicator.close()
      })
    },
    more: function () {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      let _this = this
      this.searchCondition.pageNo = parseInt(this.searchCondition.pageNo) + 1
      this.axios.get('/url/fund/fundHistory?showCount=30&pageNo=' + this.searchCondition.pageNo + '&accountId=' + _this.accountId + '')
      .then(function (res) {
        Indicator.close()
        _this.fundList = res.data.data.list
        if (_this.fundList.length !== 30) {
          _this.allLoaded = true
        }
      }).catch(function (response) {
        Indicator.close()
      })
    }
  }
}
</script>

<style scoped>
.tradeRecords{
  background-color: #f0eff5;
  padding-bottom: 1px;
}
.list_wrap{
  margin-bottom: 70px;
}
.list{
  border-bottom: 1px solid #ccc;
  padding: 11px 18px;
  overflow: hidden;
  background-color: #fff;
}
.list div{
  float: left;
}
.list div:nth-child(1){
  width: 60%;
}
.list div:nth-child(1) p{
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.list div:nth-child(1) span{
  font-size: 12px;
  color: #9e9e9e;
}
.list div:nth-child(2){
  font-size: 14px;
  width: 40%;
  text-align: right;
}
.output{
  color: #108eeb;
}
</style>


// WEBPACK FOOTER //
// tradeRecords.vue?25f1a2a0